var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var	ReactDOM = require('react-dom');
var PropTypes = require('prop-types');

var Callout = createReactClass({

    handleClick: function() {
        var element = ReactDOM.findDOMNode(this.refs.myCallout)
        $(element).fadeOut().trigger('closed.zf')
        this.props.handleClose();
    },

  render: function(){
    return (
      <div className={this.props.type + ' callout'} ref='myCallout' data-closable>
        <p>{this.props.message}</p>
        <button className="close-button" aria-label="Dismiss alert" type="button"
          onClick={this.handleClick}>
          <span className="ion-ios-close-empty"></span>
        </button>
      </div>
    )
  }
});

Callout.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired
};

module.exports = Callout;



// WEBPACK FOOTER //
// ./src/common/routes/components/callout.jsx